import React from 'react'

export default function MenuDivider() {
  return <hr className="c-header-dropdown__hr" />
}

MenuDivider.propTypes = {}
